import React, { useState } from "react"
import { Checkbox, Input, Modal, message } from "antd"
import { request } from "../../utils/config"
import FileAttach from "../upload/FileAttach"   // tog'a #1920 (2026-09-14): prava/texpasport fayli

// tog'a 1793 (2026-09-13): YANGI SHOFYOR oynasi — sotuv (SaleForm) va yetkazma (DeliveryForm) uchun UMUMIY.
// Karta (mainDriver) har doim ochiladi: ism/tel/transport/davlat raqami/prava/texpasport.
// Login (mobil ilova) IXTIYORIY — faqat checkbox belgilansa; unga «Логины и пароли» huquqi kerak.
type Props = {
  visible: boolean
  onClose: () => void
  onCreated: (row: any) => void
}

const EMPTY = { name: "", lastname: "", phone: "", vehicleInfo: "", vehiclePlate: "", licenseNumber: "", vehiclePassportNumber: "", licenseFile: "", vehiclePassportFile: "", email: "", password: "" }

export default function NewDriverModal({ visible, onClose, onCreated }: Props) {
  const [nd, setNd] = useState<any>(EMPTY)
  const [withLogin, setWithLogin] = useState(false)
  const [busy, setBusy] = useState(false)
  const save = async () => {
    if (!nd.name.trim() || !nd.phone.trim()) return message.warning("Укажите имя и телефон водителя")
    if (withLogin && (!nd.email.trim() || !nd.password)) return message.warning("Укажите логин (e-mail) и пароль водителя")
    setBusy(true)
    try {
      const r = await request({
        url: "Deliveries/Drivers",
        method: "POST",
        data: {
          name: nd.name.trim(),
          lastname: nd.lastname.trim(),
          phone: nd.phone.trim(),
          vehicleInfo: nd.vehicleInfo.trim() || null,
          vehiclePlate: nd.vehiclePlate.trim() || null,
          licenseNumber: nd.licenseNumber.trim() || null,
          vehiclePassportNumber: nd.vehiclePassportNumber.trim() || null,
          licenseFile: nd.licenseFile || null,               // tog'a #1920: hujjat fayli haydovchi kartasida saqlanadi
          vehiclePassportFile: nd.vehiclePassportFile || null,
          withoutLogin: !withLogin,
          email: withLogin ? nd.email.trim() : null,
          password: withLogin ? nd.password : null,
        },
      })
      message.success("Водитель сохранён и выбран: " + [nd.name.trim(), nd.lastname.trim()].filter(Boolean).join(" "))
      onCreated(r.data)
      setNd(EMPTY)
      setWithLogin(false)
      onClose()
    } catch (e: any) {
      message.error(e?.response?.data?.message || e?.response?.data?.Message || "Водитель не создан", 8)
    } finally {
      setBusy(false)
    }
  }
  return (
    <Modal
      zIndex={1010} // drawer 1000 / modal 1010 konvensiyasi — aks holda oyna forma ORQASIDA qoladi (jonli skrinshot 2026-09-12)
      title="Новый водитель"
      visible={visible}
      onCancel={onClose}
      onOk={save}
      okText="Сохранить и выбрать"
      cancelText="Отмена"
      confirmLoading={busy}
      destroyOnClose
    >
      <Input size="large" placeholder="Имя *" value={nd.name} onChange={(e) => setNd({ ...nd, name: e.target.value })} style={{ marginBottom: 8 }} />
      <Input size="large" placeholder="Фамилия" value={nd.lastname} onChange={(e) => setNd({ ...nd, lastname: e.target.value })} style={{ marginBottom: 8 }} />
      <Input size="large" placeholder="Телефон *" value={nd.phone} onChange={(e) => setNd({ ...nd, phone: e.target.value })} style={{ marginBottom: 8 }} />
      <Input size="large" placeholder="Транспорт (модель), напр. Cobalt" value={nd.vehicleInfo} onChange={(e) => setNd({ ...nd, vehicleInfo: e.target.value })} style={{ marginBottom: 8 }} />
      <Input size="large" placeholder="Гос. номер, напр. 01A123BC" value={nd.vehiclePlate} onChange={(e) => setNd({ ...nd, vehiclePlate: e.target.value })} style={{ marginBottom: 8 }} />
      <Input size="large" placeholder="№ водительского удостоверения (права)" value={nd.licenseNumber} onChange={(e) => setNd({ ...nd, licenseNumber: e.target.value })} style={{ marginBottom: 8 }} />
      <div style={{ marginBottom: 8, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        <span style={{ color: "#64748b", fontSize: 12 }}>Файл водительского удостоверения:</span>
        <FileAttach value={nd.licenseFile || undefined} onChange={(v) => setNd({ ...nd, licenseFile: v || "" })} />
      </div>
      <Input size="large" placeholder="№ техпаспорта" value={nd.vehiclePassportNumber} onChange={(e) => setNd({ ...nd, vehiclePassportNumber: e.target.value })} style={{ marginBottom: 8 }} />
      <div style={{ marginBottom: 8, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        <span style={{ color: "#64748b", fontSize: 12 }}>Файл техпаспорта:</span>
        <FileAttach value={nd.vehiclePassportFile || undefined} onChange={(v) => setNd({ ...nd, vehiclePassportFile: v || "" })} />
      </div>
      <Checkbox checked={withLogin} onChange={(e) => setWithLogin(e.target.checked)} style={{ marginBottom: 8 }}>
        Создать логин водителя (мобильное приложение) — нужно право «Логины и пароли»
      </Checkbox>
      {withLogin && (
        <>
          <Input size="large" placeholder="Логин (e-mail) *" value={nd.email} onChange={(e) => setNd({ ...nd, email: e.target.value })} style={{ marginBottom: 8 }} />
          <Input.Password size="large" placeholder="Пароль *" value={nd.password} onChange={(e) => setNd({ ...nd, password: e.target.value })} />
        </>
      )}
    </Modal>
  )
}
